import { IPolicy } from '../models';
import * as moment from 'moment';
import { getIncludedResource } from '../util';
import * as document from './documents';

const dateFromApi = (date) => {
  if (! date) {
    return '';
  }

  const parsedDate = moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');

  return parsedDate !== 'Invalid Date' ? parsedDate : '';
};

export function fromJsonApi(data, included: any[]): IPolicy {
  const documents = getIncludedResource(data, included, 'documents', true)
    .map((item) => document.fromJsonApi(item, included));

  return {
    policyNumber: data.attributes.policy_number,
    id: data.id,
    insured: data.attributes.insured,
    status: data.attributes.status,
    version: data.attributes.version,
    productName: data.attributes.product_name,
    userName: data.attributes.user_name,
    brokerName: data.attributes.broker_name,
    channelName: data.attributes.channel_name,
    minimumDocumentCount: data.attributes.minimum_document_count,
    isInsideCancellationPeriod: data.attributes.is_inside_cancellation_period,
    metadata: data.attributes.metadata,
    commencesAt: dateFromApi(data.attributes.commences_at),
    expiresAt: dateFromApi(data.attributes.expires_at),
    issuedAt: data.attributes.issued_at,
    cancelledAt: data.attributes.cancelled_at,
    totalPremiumValue: data.attributes.total_premium_value,
    documents,
    renewalStatus: data.attributes.renewal_status,
  };
}
